module.exports = __webpack_public_path__ + "static/media/sensor.c6485a2c.svg";